module.exports = "<fw-page-header-bar [config]=\"config.pageHeaderBarConfig\" (btnClick)=\"btnHeaderBarClicked($event)\"></fw-page-header-bar>\r\n\r\n<fw-dynamic-grid [vmColumnDefinition]=\"config.columnDefinition\" [rowKey]=\"config.rowKey\" (gridRowDoubleClick)=\"gridRowDoubleClicked($event)\"></fw-dynamic-grid>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/pages/page-list.component.html
// module id = 2275
// module chunks = 1